import { APP_INITIALIZER, inject, NgModule } from '@angular/core';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { InMemoryCache } from '@apollo/client/cache';
import { FlyFreelyConstants } from '@flyfreely-portal-ui/flyfreely';
import { GraphqlSubscriptionStateService } from './graphql-subscription-state.service';

/**
 * A standalone module to initialise Apollo for use with both http queries and websocket subscriptions.
 * Initialising this way also allows one location for all the common Apollo configuration.
 * Each app that utilises Graph QL can import this module in the app module in place of having an Apollo options factory function.
 */
@NgModule({
    providers: [
        provideApollo(() => {
            const httpLink = inject(HttpLink);
            const constants = inject(FlyFreelyConstants);

            return {
                link: httpLink.create({
                    uri: `${constants.API_URL}/graphql`
                }),
                cache: new InMemoryCache()
            };
        }),
        GraphqlSubscriptionStateService,
        {
            provide: APP_INITIALIZER,
            multi: true,
            useFactory: () => () => null,
            deps: [GraphqlSubscriptionStateService]
        }
    ]
})
export class GraphQlModule {}
